//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import BottomNotification from '.';

import {useToggle} from '../../../../../../../../utils/react';
import CustomModal from '../../../../../../../../elements/CustomModal/CustomModal';

import {colors} from '../../../../../../../../assets/styles/colors';
import {getStringDate} from '../../../../../../../../utils/date';
import {useCurrentConversationScheduleMessage} from '../../../../../../schedule-messages/utils';
import {useCurrentConversation} from '../../../../../utils/conversation';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
    width: '100%',
    paddingBlock: '1rem',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  messageItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: '.5rem',
    borderTop: `1px solid ${colors.grey300}`,
  },
  messageItemText: {
    fontSize: '1rem',
    maxWidth: '300px',
    fontWeight: 500,
  },
  modalPaper: {
    width: '100%',
    maxWidth: '400px',
    padding: '0 1rem 1rem',
    borderRadius: '1rem',
    boxShadow: '0px -4px 20px 0px rgba(0, 0, 0, 0.06)',
  },
  messageItemDate: {
    fontSize: '1rem',
    color: colors.grey500,
  },
}));

export default function ScheduleMessageNotification() {
  const classes = useStyles();

  const currentConversation = useCurrentConversation();
  const {pendingMessages} = useCurrentConversationScheduleMessage();

  const [modalOpen, toggleModal] = useToggle();
  if (!pendingMessages.length || !currentConversation) return null;

  return (
    <>
      <BottomNotification
        color="success"
        label="Mensajes programados"
        count={pendingMessages.length > 9 ? '9+' : pendingMessages.length}
        onClick={toggleModal}
      />
      <CustomModal
        open={modalOpen}
        handleCloseModal={toggleModal}
        classes={{
          paper: classes.modalPaper,
        }}
      >
        <div className={classes.root}>
          <header className={classes.title}>Mensajes programados</header>

          <div className={classes.content}>
            {pendingMessages.map(scheduleMessage => (
              <div key={scheduleMessage.id} className={classes.messageItem}>
                <div className={classes.messageItemText}>
                  {scheduleMessage.message.text}
                </div>
                <div className={classes.messageItemDate}>
                  Programado para el{' '}
                  {getStringDate(new Date(scheduleMessage.sendAt))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CustomModal>
    </>
  );
}
